import { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from 'ui/label'
import { Switch } from 'ui/switch'

import { extractCssVariableValue } from '~/utils/extract-css-variable-value'
import { getIsDarkMode } from '~/utils/get-is-dark-mode'
import { hslToHex } from '~/utils/hsl-to-hex'
import { setMetaTheme } from '~/utils/set-meta-theme'

export const DarkModeToggler = () => {
  const id = useId()
  const [isDarkMode, setIsDarkMode] = useState(getIsDarkMode())

  const { t } = useTranslation()

  return (
    <section className="flex items-center gap-2">
      <Switch
        checked={isDarkMode}
        id={id}
        onCheckedChange={isChecked => {
          setIsDarkMode(isChecked)
          if (isChecked) {
            localStorage.theme = 'dark'
            document.documentElement.classList.add('dark')

            return setMetaTheme(hslToHex(extractCssVariableValue('--background')))
          }

          localStorage.theme = 'light'
          document.documentElement.classList.remove('dark')
          setMetaTheme(hslToHex(extractCssVariableValue('--background')))
        }}
      />
      <Label htmlFor={id}>{t('Dark Mode')}</Label>
    </section>
  )
}
